import {CreditCard} from "./credit-card";

export class PaymentMethod {

  public id: number;
  public clientId: number;
  public creditCard: CreditCard;
  public active: boolean;

}
